// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/loader-circle.js';

import { paths } from '../generated/loader-circle';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('loader-circle', Original, paths);
